$(document).ready(function () {
    const settleDelay = 200;
    const watched = new WeakMap();

    const isFullyVisible = function (video) {
        const rect = video.getBoundingClientRect();
        return (
            rect.top >= $.constants.menuHeight &&
            rect.bottom <= window.innerHeight
        );
    };

    const align = function (video) {
        if (isFullyVisible(video)) return;

        const target = Math.max(
            video.getBoundingClientRect().top +
                window.scrollY -
                $.constants.menuHeight,
            0
        );

        if (Math.abs(window.scrollY - target) < 2) return;

        window.scrollTo(0, target);
    };

    const watch = function (video) {
        if (watched.has(video)) return;

        const state = { timer: null, observer: null };
        watched.set(video, state);

        const release = function () {
            window.clearTimeout(state.timer);
            if (state.observer) state.observer.disconnect();
            watched.delete(video);
        };

        const settle = function () {
            window.clearTimeout(state.timer);
            state.timer = window.setTimeout(function () {
                align(video);
            }, settleDelay);
        };

        video.addEventListener("pause", release, { once: true });
        video.addEventListener("ended", release, { once: true });

        if (typeof ResizeObserver === "undefined") {
            settle();
            return;
        }

        state.observer = new ResizeObserver(settle);
        state.observer.observe(video);
    };

    document.addEventListener(
        "play",
        function (event) {
            const video = event.target;
            if (!(video instanceof HTMLVideoElement)) return;
            if (!video.controls || video.autoplay) return;

            watch(video);
        },
        true
    );
});
